import User from '@/core/user'

export default {
  get: function () {
    let model = {
      'Id': {
        label: '_'
      },

      '*BusinessUnitName': {
        label: 'Business Unit'
      },

      'CostCenterNo': {
        label: 'Cost Center ID'
      },

      'CostCenterName': {
        label: 'Cost Center Name'
      },

      'DivisionName': {
        label: getDivisionName()
      }
    }

    return model
  }
}

function getDivisionName() {
  return User.get().settings['DivisionName']
}



// WEBPACK FOOTER //
// ./src/components/_modules/BusinessUnitsAndCostCenters/BU-CC-list/BUCCModel.js